import React from 'react';
import { Box, Typography } from '@mui/material';

import { ECardTypes } from 'shared/types/card.interface';
import { IChallangeData } from 'shared/types/challenges.interface';
import { PAGE_PLACEHOLDERS_DATA } from 'shared/constants/no-content-constants';
import Card from 'components/Card/Card';
import SkeletonCardList from 'components/Skeletons/CardSkeleton/SkeletonCardList/SkeletonCardList';
import { useGetAllChallengesQuery } from 'redux/api/challenge.api';
import { CardsContainer } from 'components/Card/CardsContainer/CardsContainer';
import { PageContainer } from 'pages/PageContainer';

const ChallengesFeed: React.FunctionComponent<any> = () => {
  const { data: allChallenges = [], isLoading } = useGetAllChallengesQuery(undefined, {
    pollingInterval: 1000,
    refetchOnMountOrArgChange: true,
  });

  return (
    <PageContainer>
      <CardsContainer>
        {isLoading ? (
          <SkeletonCardList />
        ) : allChallenges.length ? (
          allChallenges.map((challenge: IChallangeData) => (
            <Card cardInfo={challenge} type={ECardTypes.Challenge} key={challenge.id} />
          ))
        ) : (
          <Box sx={{ width: '100%', textAlign: 'center' }}>
            <Typography variant="body1" color="primary.main">
              {PAGE_PLACEHOLDERS_DATA.challengesFeed}
            </Typography>
          </Box>
        )}
      </CardsContainer>
    </PageContainer>
  );
};

export default ChallengesFeed;
